module.exports = __webpack_public_path__ + "static/media/pago3.71720258.svg";